import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getStorage } from 'firebase/storage';
import { getAnalytics } from 'firebase/analytics';

// Your web app's Firebase configuration - NEW PROJECT
const firebaseConfig = {
  apiKey: "AIzaSyAFlFc4ntwsYEVsamRBqOd91F-jPLjFmGI",
  authDomain: "my-cal-d47a3.firebaseapp.com",
  projectId: "my-cal-d47a3",
  storageBucket: "my-cal-d47a3.firebasestorage.app",
  messagingSenderId: "895720846087",
  appId: "1:895720846087:web:45cad15cc02e20c4820ba2",
  measurementId: "G-HTH8EB7JJB"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app, 'us-central1');
export const storage = getStorage(app);
export const analytics = getAnalytics(app);

// Force production mode - no emulators
// Ensure functions are properly configured for production
if (typeof window !== 'undefined') {
  // Clear any cached function configurations
  console.log('Configuring Firebase Functions for production');
}

export default app;